import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=e5f69c3c&"
import script from "./Captcha.vue?vue&type=script&lang=js&"
export * from "./Captcha.vue?vue&type=script&lang=js&"
import style0 from "./Captcha.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports